"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.span = exports.p = exports.Common = void 0;
exports.Common = {
    "Text48Left": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text48Left\""
    },
    "Text48Center": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text48Center\""
    },
    "Text32Left": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text32Left\""
    },
    "Text32Center": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text32Center\""
    },
    "Text32EmphasisLeft": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text32EmphasisLeft\""
    },
    "Text32Italic": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text32Italic\""
    },
    "Text32EmphasisItalic": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text32EmphasisItalic\""
    },
    "Text32EmphasisCenter": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text32EmphasisCenter\""
    },
    "Text24Left": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text24Left\""
    },
    "Text24Center": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text24Center\""
    },
    "Text24EmphasisLeft": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text24EmphasisLeft\""
    },
    "Text24EmphasisCenter": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text24EmphasisCenter\""
    },
    "Text24Italic": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text24Italic\""
    },
    "Text24EmphasisItalic": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text24EmphasisItalic\""
    },
    "Text20Left": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text20Left\""
    },
    "Text20Right": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text20Right\""
    },
    "Text20EmphasisLeft": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisLeft\""
    },
    "Text20EmphasisCenter": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisCenter\""
    },
    "Text20EmphasisRight": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisRight\""
    },
    "Text20Italic": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text20Italic\""
    },
    "Text20EmphasisItalic": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text20EmphasisItalic\""
    },
    "Text16Left": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Left\""
    },
    "Text16Center": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Center\""
    },
    "Text16Right": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Right\""
    },
    "Text16SecondaryLeft": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16SecondaryCenter": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryCenter\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16SecondaryRight": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16EmphasisLeft": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisLeft\""
    },
    "Text16EmphasisCenter": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisCenter\""
    },
    "Text16EmphasisRight": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisRight\""
    },
    "Text16Italic": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text16Italic\""
    },
    "Text16EmphasisItalic": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text16EmphasisItalic\""
    },
    "Text14Left": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14Left\""
    },
    "Text14Right": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14Right\""
    },
    "Text14SecondaryLeft": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text14SecondaryRight": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text14EmphasisLeft": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text14EmphasisLeft\""
    },
    "Text14EmphasisRight": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text14EmphasisRight\""
    },
    "Text14Italic": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text14Italic\""
    },
    "Text14EmphasisItalic": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text14EmphasisItalic\""
    },
    "Text12Left": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12Left\""
    },
    "Text12Right": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12Right\""
    },
    "Text12SecondaryLeft": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text12SecondaryRight": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text12EmphasisLeft": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text12EmphasisLeft\""
    },
    "Text12EmphasisRight": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text12EmphasisRight\""
    },
    "Text12Italic": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text12Italic\""
    },
    "Text12EmphasisItalic": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text12EmphasisItalic\""
    },
    "Slab48Left": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab48Left\""
    },
    "Slab48Center": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab48Center\""
    },
    "Slab40Left": {
        "font-size": "2.5rem",
        "line-height": "3rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab40Left\""
    },
    "Slab40Center": {
        "font-size": "2.5rem",
        "line-height": "3rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab40Center\""
    },
    "Slab32Left": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab32Left\""
    },
    "Slab32Center": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab32Center\""
    },
    "Slab24Left": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab24Left\""
    },
    "Slab24Center": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab24Center\""
    }
};
exports.p = {
    "Text48Left": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text48Left\""
    },
    "Text48Center": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text48Center\""
    },
    "Text32Left": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text32Left\""
    },
    "Text32Center": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text32Center\""
    },
    "Text32EmphasisLeft": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text32EmphasisLeft\""
    },
    "Text32Italic": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text32Italic\""
    },
    "Text32EmphasisItalic": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text32EmphasisItalic\""
    },
    "Text32EmphasisCenter": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text32EmphasisCenter\""
    },
    "Text24Left": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text24Left\""
    },
    "Text24Center": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text24Center\""
    },
    "Text24EmphasisLeft": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text24EmphasisLeft\""
    },
    "Text24EmphasisCenter": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text24EmphasisCenter\""
    },
    "Text24Italic": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text24Italic\""
    },
    "Text24EmphasisItalic": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text24EmphasisItalic\""
    },
    "Text20Left": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text20Left\""
    },
    "Text20Right": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text20Right\""
    },
    "Text20EmphasisLeft": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisLeft\""
    },
    "Text20EmphasisCenter": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisCenter\""
    },
    "Text20EmphasisRight": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisRight\""
    },
    "Text20Italic": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text20Italic\""
    },
    "Text20EmphasisItalic": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text20EmphasisItalic\""
    },
    "Text16Left": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Left\""
    },
    "Text16Center": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Center\""
    },
    "Text16Right": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Right\""
    },
    "Text16SecondaryLeft": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16SecondaryCenter": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryCenter\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16SecondaryRight": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16EmphasisLeft": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisLeft\""
    },
    "Text16EmphasisCenter": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisCenter\""
    },
    "Text16EmphasisRight": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisRight\""
    },
    "Text16Italic": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text16Italic\""
    },
    "Text16EmphasisItalic": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text16EmphasisItalic\""
    },
    "Text14Left": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14Left\""
    },
    "Text14Right": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14Right\""
    },
    "Text14SecondaryLeft": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text14SecondaryRight": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text14EmphasisLeft": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text14EmphasisLeft\""
    },
    "Text14EmphasisRight": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text14EmphasisRight\""
    },
    "Text14Italic": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text14Italic\""
    },
    "Text14EmphasisItalic": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text14EmphasisItalic\""
    },
    "Text12Left": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12Left\""
    },
    "Text12Right": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12Right\""
    },
    "Text12SecondaryLeft": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text12SecondaryRight": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text12EmphasisLeft": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text12EmphasisLeft\""
    },
    "Text12EmphasisRight": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text12EmphasisRight\""
    },
    "Text12Italic": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text12Italic\""
    },
    "Text12EmphasisItalic": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text12EmphasisItalic\""
    },
    "Slab48Left": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab48Left\""
    },
    "Slab48Center": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab48Center\""
    },
    "Slab40Left": {
        "font-size": "2.5rem",
        "line-height": "3rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab40Left\""
    },
    "Slab40Center": {
        "font-size": "2.5rem",
        "line-height": "3rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab40Center\""
    },
    "Slab32Left": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab32Left\""
    },
    "Slab32Center": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab32Center\""
    },
    "Slab24Left": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab24Left\""
    },
    "Slab24Center": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab24Center\""
    }
};
exports.span = {
    "Text48Left": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text48Left\""
    },
    "Text48Center": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text48Center\""
    },
    "Text32Left": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text32Left\""
    },
    "Text32Center": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text32Center\""
    },
    "Text32EmphasisLeft": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text32EmphasisLeft\""
    },
    "Text32Italic": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text32Italic\""
    },
    "Text32EmphasisItalic": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text32EmphasisItalic\""
    },
    "Text32EmphasisCenter": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text32EmphasisCenter\""
    },
    "Text24Left": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text24Left\""
    },
    "Text24Center": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text24Center\""
    },
    "Text24EmphasisLeft": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text24EmphasisLeft\""
    },
    "Text24EmphasisCenter": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text24EmphasisCenter\""
    },
    "Text24Italic": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text24Italic\""
    },
    "Text24EmphasisItalic": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text24EmphasisItalic\""
    },
    "Text20Left": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text20Left\""
    },
    "Text20Right": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text20Right\""
    },
    "Text20EmphasisLeft": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisLeft\""
    },
    "Text20EmphasisCenter": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisCenter\""
    },
    "Text20EmphasisRight": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text20EmphasisRight\""
    },
    "Text20Italic": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text20Italic\""
    },
    "Text20EmphasisItalic": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text20EmphasisItalic\""
    },
    "Text16Left": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Left\""
    },
    "Text16Center": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Center\""
    },
    "Text16Right": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16Right\""
    },
    "Text16SecondaryLeft": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16SecondaryCenter": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryCenter\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16SecondaryRight": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text16SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text16EmphasisLeft": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisLeft\""
    },
    "Text16EmphasisCenter": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisCenter\""
    },
    "Text16EmphasisRight": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text16EmphasisRight\""
    },
    "Text16Italic": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text16Italic\""
    },
    "Text16EmphasisItalic": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text16EmphasisItalic\""
    },
    "Text14Left": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14Left\""
    },
    "Text14Right": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14Right\""
    },
    "Text14SecondaryLeft": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text14SecondaryRight": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text14SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text14EmphasisLeft": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text14EmphasisLeft\""
    },
    "Text14EmphasisRight": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text14EmphasisRight\""
    },
    "Text14Italic": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text14Italic\""
    },
    "Text14EmphasisItalic": {
        "font-size": ".875rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text14EmphasisItalic\""
    },
    "Text12Left": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12Left\""
    },
    "Text12Right": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12Right\""
    },
    "Text12SecondaryLeft": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12SecondaryLeft\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text12SecondaryRight": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "--textstyle": "\"Text12SecondaryRight\"",
        "color": "#706d6e",
        "--color": "\"textDarkSecondary\""
    },
    "Text12EmphasisLeft": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text12EmphasisLeft\""
    },
    "Text12EmphasisRight": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "right",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Text12EmphasisRight\""
    },
    "Text12Italic": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "400",
        "font-style": "italic",
        "--textstyle": "\"Text12Italic\""
    },
    "Text12EmphasisItalic": {
        "font-size": ".75rem",
        "line-height": "1.25rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "font-style": "italic",
        "--textstyle": "\"Text12EmphasisItalic\""
    },
    "Slab48Left": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab48Left\""
    },
    "Slab48Center": {
        "font-size": "3rem",
        "line-height": "3.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab48Center\""
    },
    "Slab40Left": {
        "font-size": "2.5rem",
        "line-height": "3rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab40Left\""
    },
    "Slab40Center": {
        "font-size": "2.5rem",
        "line-height": "3rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab40Center\""
    },
    "Slab32Left": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab32Left\""
    },
    "Slab32Center": {
        "font-size": "2rem",
        "line-height": "2.5rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab32Center\""
    },
    "Slab24Left": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "left",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab24Left\""
    },
    "Slab24Center": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "text-align": "center",
        "font-family": "CBABeaconSans,sans-serif",
        "font-weight": "800",
        "--textstyle": "\"Slab24Center\""
    }
};
